"use client";

const replays = [
  {
    id: "ls20",
    label: "agentic player-based puzzle",
    src: "/videos/arc-agi-3/ls20.mov",
  },
  {
    id: "vc33",
    label: "budgeting non-agentic puzzle",
    src: "/videos/arc-agi-3/vc33.mov",
  },
  {
    id: "ft09",
    label: "abstract logic pattern matching",
    src: "/videos/arc-agi-3/ft09.mov",
  },
];

export function Replays() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
      {replays.map((r) => (
        <div key={r.id} className="flex flex-col gap-2">
          <div
            style={{
              fontSize: "12px",
              fontFamily: "'IBM Plex Mono', monospace",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            <span style={{ color: "#9B9DFF", fontWeight: 500 }}>{r.id}</span>{" "}
            <span style={{ color: "rgba(255,255,255,0.55)" }}>{r.label}</span>
          </div>
          <video
            src={r.src}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              borderRadius: "0.5rem",
              display: "block",
              border: "1px solid rgba(255,255,255,0.08)",
            }}
            ref={(el) => {
              if (el) el.playbackRate = 0.5;
            }}
          />
        </div>
      ))}
    </div>
  );
}
